import React from "react";
import { Outlet } from "react-router-dom";

import useNeedsApproval from "../../hooks/useNeedsApproval";

export default function SuperAdminView() {
	const needsApproval = useNeedsApproval();

	return <Outlet context={{ needsApproval }} />;
}
